import React, { useEffect, useState } from "react";
import { urlAPI } from "../../services/api.services";
import { useAppContext } from "../../context/AppContext";

const Footer = () => {
  const {
    social = [],
    contact = {},
    landingpage = {},
    menu = [],
  } = useAppContext();

  const [landingPage, setLandingpage] = useState({});

  // sync context to local state
  useEffect(() => {
    if (landingpage) setLandingpage(landingpage);
  }, [landingpage]);

  return (
    <footer className="w-full bg-darkColor text-white p-14 pt-0">
      {/* Logo (mobile) */}
      {landingPage.landing_banner_logo && (
        <a href="/" className="block lg:hidden mx-auto mt-10">
          <img
            src={urlAPI + landingPage.landing_banner_logo}
            alt={landingPage?.landing_banner_logo_alt || 'Logo Prisma Multimedia'}
            className="h-20 object-cover"
          />
        </a>
      )}

      {/* Copyright */}
      <p className="alegreya-sans-light text-center pt-10 md:py-10">
        2024 &copy; Prisma Multimedia
      </p>

      <div className="lg:flex justify-between items-start lg:items-center text-center lg:text-left gap-10">
        {/* Left Section: Logo & Socials */}
        <div>
          {landingPage.landing_banner_logo && (
            <a href="/" className="hidden lg:block mb-6">
              <img
                src={urlAPI + landingPage.landing_banner_logo}
                alt={landingPage?.landing_banner_logo_alt || 'Logo Prisma Multimedia'}
                className="h-20 object-cover"
              />
            </a>
          )}

          <div className="flex flex-wrap justify-center lg:justify-start gap-4 md:gap-8 mt-6">
            {/* {social.map((item) => (
              <a key={item.id || item.url} href={item.url}>
                <img
                  src={urlAPI + item.icon_url}
                  alt={item.name || "social"}
                  className="h-10 md:h-14"
                />
              </a>
            ))} */}
            {social?.length > 0 &&
              social.map((item) => {
                const isWhatsapp =
                  item.name?.toLowerCase() === "whatsapp";

                const whatsappId = isWhatsapp
                  ? item.number_id
                    ? `btn-wa${item.number_id}`
                    : "btn-wa"
                  : undefined;

                // WhatsApp di footer harus menggunakan URL default
                const footerUrl = isWhatsapp
                  ? item.url?.replace(/&sales_number=[^&]*/i, "")
                  : item.url;

                return (
                  <a
                    key={item.id || item.url}
                    id={whatsappId}
                    href={footerUrl}
                  >
                    <img
                      src={urlAPI + item.icon_url}
                      alt={item.name || "social"}
                      className="h-10 md:h-14"
                    />
                  </a>
                );
              })}
          </div>
        </div>

        {/* Middle Section: Menu */}
        <div className="mt-10 lg:mt-0">
          <p className="md:text-xl font-semibold">EXPLORE</p>
          <div className="flex gap-20 md:gap-40 mt-4 justify-center">
            {[0, 3].map((start) => (
              <div key={start} className="text-left">
                {Array.isArray(menu) && menu.slice(start, start + 3).map((item) => (
                  <div key={item.id || item.url} className="mb-2">
                    <a href={item.url}>{item.name}</a>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Right Section: Contact */}
        <div className="mt-10 lg:mt-0 lg:text-right max-w-sm mx-auto lg:mx-0">
          <p className="md:text-xl font-semibold">PT Prisma Multimedia Solusi</p>
          {contact?.landing_contact_address && (
            <div
              className="mt-2 font-normal"
              dangerouslySetInnerHTML={{
                __html: contact.landing_contact_address,
              }}
            />
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
